import { Modal, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import React from 'react';
import { connect } from 'react-redux';
import { setRecoverableError } from '../../actions/ui';
import { SUPPORT_MAILING_ADDRESS } from './errorConstants';

export const RecoverableError = ({ isOpen, setOpen }) => {
    return <Modal isOpen={isOpen} onClose={(e) => setOpen(false)} unstable_ModalBackdropScroll>
        <ModalHeader>
            An error occurred. We've tried to fix this as best we can, but if this problem persists,
            please contact support <a href={"mailto:" + SUPPORT_MAILING_ADDRESS}>here.</a>
        </ModalHeader>
        <ModalFooter>
            <ModalButton onClick={() => setOpen(false)}>Okay</ModalButton>
        </ModalFooter>
    </Modal>
}

export default connect(state => ({
    isOpen: state.ui.error && state.ui.error !== 'irrecoverable'
}), {
    setOpen: setRecoverableError
})(RecoverableError);